'use client'

import type { SelectDropdownProps } from '@pearlconvert/ui/components/select/select.types'

export default function SelectDropdown({
  name,
  ariaLabel,
  className,
  options,
  listRef,
  isDropdownOpen,
  selectedOption,
  activeIndex,
  setActiveIndexAction,
  handleMouseClickAction,
  handleMouseLeaveOptionAction,
  optionRefs,
}: SelectDropdownProps) {
  return (
    <div
      className={`select__root select__dropdown
        ${isDropdownOpen ? ' select__dropdown--open' : ''}
        ${className ? ' ' + className : ''}`}
      id={`${name}_select_dropdown`}
    >
      <ul
        ref={listRef}
        role="listbox"
        className="select__list"
        aria-multiselectable={false}
        aria-label={ariaLabel}
        aria-activedescendant={
          activeIndex >= 0
            ? `${name}_select_element_${options[activeIndex]?.value}`
            : undefined
        }
        tabIndex={0}
      >
        {options.map(({ label, value }, index) => {
          return (
            <li
              key={`option-${value}-${index}`}
              className={`select__list-option${
                value === selectedOption?.value
                  ? ' select__list-option--chosen'
                  : ''
              } ${index === activeIndex ? ' select__list-option--highlighted' : ''}`}
              id={`${name}_select_element_${value}`}
              onClick={() => handleMouseClickAction(value)}
              onMouseEnter={() => setActiveIndexAction(index)}
              onMouseLeave={() => handleMouseLeaveOptionAction(index)}
              onFocus={() => setActiveIndexAction(index)}
              role="option"
              aria-selected={value === selectedOption?.value}
              tabIndex={index === activeIndex ? 0 : -1}
              ref={(el) => {
                if (optionRefs.current) {
                  optionRefs.current[index] = el
                }
              }}
            >
              <span className="select__list-label">{label}</span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
